import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { APIS } from "../../../../utils/APIS";
import { GET, POST, PUT, DELETE } from "../../../../utils/Methods";
import { IDS } from "../../../../utils/IDS";

// Country - Get All (Read)
export const GetAll = createAsyncThunk(
  "property/get-all-property",
  async (filter, { rejectWithValue }) => {
    try {
      const res = await GET(
        `${APIS.Property?.Get_Property}?name=${filter?.name || ""}&property_status_id=${
          filter?.property_status_id || ""
        }&purpose_id=${filter?.purpose_id || ""}&property_type_id=${
          filter?.property_type_id || ""
        }&posted_by_id=${filter?.posted_by_id || ""}&page=${
          filter?.page || IDS.PAGE
        }&per_page=${filter?.per_page || IDS.PERPAGE}`,
      );
      return res;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const UpdateStatus = createAsyncThunk(
  "property/get-all-property/update",
  async ({ id, data }, { rejectWithValue }) => {
    try {
      const res = await PUT(
        `${APIS.Property?.Get_Property}/change-status/${id}`,
        data,
      );
      return res;
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

export const Status = createAsyncThunk(
  "property/get-all-property/status",
  async (id, { rejectWithValue }) => {
    try {
      const res = await POST(`${APIS.Property?.Get_Property}/${id}`);
      return res;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const Slice = createSlice({
  name: "property-get",
  initialState: {
    data: [],
    current_page: IDS.PAGE,
    total_pages: IDS.TOTALPAGES,
    per_page: IDS.PERPAGE,
    total: IDS.TOTAL,
    status: IDS.SLICESTATUS.Idle,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(GetAll.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(GetAll.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.data = action.payload?.data?.data || [];
        state.current_page = action.payload?.data?.current_page || IDS.PAGE;
        state.total_pages = action.payload?.data?.total_pages || IDS.TOTALPAGES;
        state.per_page = action.payload?.data?.per_page || IDS.PERPAGE;
        state.total = action.payload?.data?.total || IDS.TOTAL;
      })
      .addCase(GetAll.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(UpdateStatus.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(UpdateStatus.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        // state.data = action.payload;
        const index = state.data.findIndex(
          (country) => country.id === action.payload?.data?.id,
        );
        if (index !== -1) {
          state.data[index] = action.payload.data;
        }
      })
      .addCase(UpdateStatus.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })
      .addCase(Status.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(Status.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;

        const updated = action.payload?.data;

        const index = state.data.findIndex((item) => item.id === updated?.id);

        if (index !== -1) {
          state.data[index] = updated;
        }
      })
      .addCase(Status.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      });
  },
});

// Export actions (if needed in components)
export const {} = Slice.actions;

export default Slice.reducer;
